import { useOutletContext } from 'react-router-dom';
import { SessionCallPageShell } from '@/components/session-call/SessionCallPageShell';
import type { SessionCallLayoutOutletContext } from '@/constants/sessionCall';
import { getUserData } from '@/utils/cookies';

const SessaoChamadaPage = () => {
	const { setVideoCallHeaderConfig } =
		useOutletContext<SessionCallLayoutOutletContext>();
	const userDisplayName = getUserData()?.first_name?.trim() || undefined;
	return (
		<SessionCallPageShell
			viewerRole="user"
			viewerDisplayName={userDisplayName}
			exitPath="/home"
			setVideoCallHeaderConfig={setVideoCallHeaderConfig}
		/>
	);
};

export { SessaoChamadaPage };
